import { useState, useRef, useEffect } from 'react';
import { CloudUpload, Delete } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';



const ImageUploader = ({ setFiles, files, multiple, isSubmit }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const imgSize = file.size;
    const extension = file?.name.split('.')[1];
    if ((extension == 'jpg' || extension == 'png' || extension == 'PNG' || extension == 'jpeg') && imgSize <= 2097152) {
      const reader = new FileReader();
      reader.onloadend = () => {
        file['base64'] = reader.result;
        setPreview(reader.result);
        setImage(file);
        setFiles((prev) => multiple && [...prev, file]);
      };
      reader.readAsDataURL(file);
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';

        setFiles('');
      }
      toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
    }
  };
  useEffect(() => {
    setPreview('');
  }, [isSubmit]);
  const handleDelete = () => {
    setPreview('');
    setImage(null);
  };
  return (
    // <div className="flex flex-col items-center space-y-4">
    //   <label className="w-[200px] h-[120px] flex items-center justify-center bg-gray-200 rounded-lg cursor-pointer hover:bg-gray-300">
    //     <input type="file" className="hidden" accept="image/*" multiple={multiple} onChange={handleImageUpload} />
    //     <CloudUpload className="text-gray-500 text-5xl group-hover:text-gray-700" />
    //   </label>

    //   <div className="flex flex-wrap gap-2 justify-center">
    //     {files?.map((file, index) => (
    //       <div key={index} className="relative">
    //         <img src={file} className="w-[100px] h-[100px] rounded-lg object-cover border" alt={file.name} />
    //         <button
    //           className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
    //           onClick={() => handleDelete(index)}
    //         >
    //           <Delete />
    //         </button>
    //       </div>
    //     ))}
    //   </div>
    // </div>
    <div className="flex justify-center mt-2 relative group">
      {!preview && (
        <label className="w-[150px] h-[120px] flex items-center justify-center bg-gray-200 rounded-lg cursor-pointer hover:bg-gray-300">
          <input type="file" className="hidden" accept="image/*" onChange={handleImageUpload} />
          <CloudUpload className="text-gray-500 text-5xl group-hover:text-gray-700" />
        </label>
      )}

      {preview && (
        <div className="relative">
          <img src={preview} className="w-[150px] h-[120px] rounded-lg object-cover border" alt="Preview" />
          <button
            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
            onClick={handleDelete}
          >
            <Delete />
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
